/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModelClassEnum } from './ModelClassEnum';
import { ModelClassEnumFromJSON, ModelClassEnumFromJSONTyped, ModelClassEnumToJSON } from './ModelClassEnum';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface DatasetPolymorphicTabularMLDataset
 */
export interface DatasetPolymorphicTabularMLDataset {
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof DatasetPolymorphicTabularMLDataset
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {number}
   * @memberof DatasetPolymorphicTabularMLDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof DatasetPolymorphicTabularMLDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof DatasetPolymorphicTabularMLDataset
   */
  readonly hasPredictions: boolean;
  /**
   *
   * @type {ModelClassEnum}
   * @memberof DatasetPolymorphicTabularMLDataset
   */
  modelClass: ModelClassEnum;
}

/**
 * Check if a given object implements the DatasetPolymorphicTabularMLDataset interface.
 */
export function instanceOfDatasetPolymorphicTabularMLDataset(
  value: object,
): value is DatasetPolymorphicTabularMLDataset {
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('hasPredictions' in value) || value['hasPredictions'] === undefined) return false;
  if (!('modelClass' in value) || value['modelClass'] === undefined) return false;
  return true;
}

export function DatasetPolymorphicTabularMLDatasetFromJSON(json: any): DatasetPolymorphicTabularMLDataset {
  return DatasetPolymorphicTabularMLDatasetFromJSONTyped(json, false);
}

export function DatasetPolymorphicTabularMLDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DatasetPolymorphicTabularMLDataset {
  if (json == null) {
    return json;
  }
  return {
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'],
    modelClass: ModelClassEnumFromJSON(json['model_class']),
  };
}

export function DatasetPolymorphicTabularMLDatasetToJSON(
  value?: Omit<DatasetPolymorphicTabularMLDataset, 'id' | 'hasPredictions'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    dataset_path: value['datasetPath'],
    model_class: ModelClassEnumToJSON(value['modelClass']),
  };
}
